import { types, cast } from "mobx-state-tree";
import { EmploymentStatusResponse } from "../../api-models/response/EmploymentStatusResponse";
import { StorageModel } from "../storage/StorageModel";
import { endpoints } from "../api/ApiEndpoints";
import { EmploymentStatus } from "./EmploymentStatus";

const EmploymentStatusesModel = types.model({
  employmentStatuses: types.array(types.frozen<EmploymentStatus>()),
});

export const EmploymentStatusesStorageModel = types
  .compose(EmploymentStatusesModel, StorageModel)
  .named("EmploymentStatusesStorageModel")
  .actions((self) => {
    return {
      mapResponse(response: Array<EmploymentStatusResponse>) {
        self.employmentStatuses = cast(response.map((esr) => new EmploymentStatus(esr)));
      },
    };
  })
  .views((self) => ({
    get endpoint() {
      const endpoint = endpoints.get("employment_statuses");
      return endpoint;
    },
    get isLoading() {
      return !self.employmentStatuses?.length;
    },
  }));
